'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./button.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Use for all CTA Buttons - Only Rectangular Buttons Supported Currently*/
var RateGravityButton = function RateGravityButton(_ref) {
  var secondary = _ref.secondary,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['secondary', 'disabled', 'onClick', 'className', 'children']);

  return _react2.default.createElement(
    'button',
    _extends({
      className: 'button ' + (disabled ? 'button--disabled' : secondary ? 'button--secondary' : 'button--primary') + ' ' + className,
      onClick: function onClick(e) {
        //disable button clicks if disabled
        if (disabled) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        //only handle vanilla clicks
        if (_onClick && e.button === 0 && !e.altKey && !e.ctrlKey && !e.metaKey) {
          _onClick(e);
          e.stopPropagation();
          e.preventDefault();
        }
      }
    }, props),
    children
  );
};

RateGravityButton.propTypes = {
  /** Either Primary, Secondary, or disabled */
  secondary: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  /** Direct OnClick event for unwrapped buttons*/
  onClick: _propTypes2.default.func,
  /** Additional Classnames from Implementation */
  className: _propTypes2.default.string
};

RateGravityButton.defaultProps = {
  secondary: false,
  disabled: false,
  className: ''
};

exports.default = RateGravityButton;


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/components/button/index.js